import { Formik } from 'formik';
import { validationSchemaUsers, initialValuesUsers } from './UsersFormValidator';
import Form from "./CreateUsersForm";
import { useAxios } from '../../../../context/AxiosHookContext';
import { useNotification } from '../../../../context/NotificationContext';

const FormCreateUser = ({ valuesToEdit, onClose, getValues }) => {

    const axios = useAxios();
    const { showSnackbar } = useNotification();

    const handleSubmit = async (user) => {

        try {

            if (user._id) {
                await axios.put(`/users/role/${user._id}`, user)
            } 
            showSnackbar({ severity: "success", title: "Usuario", message: "Se ha actualizado el rol de forma exitosa." });

            getValues();

        } catch (error) {
            const message = error?.response?.data?.message || error?.message || "Ha ocurrido un error al crear el usuario."
            showSnackbar({ severity: "error", title: "Usuario", message })
        }

    }

    const getInitialValues = () => {
        return (valuesToEdit && Object.keys(valuesToEdit).length) > 0 ? valuesToEdit : initialValuesUsers
    }
    return (
        <Formik
            validationSchema={validationSchemaUsers}
            initialValues={getInitialValues()}
            onSubmit={handleSubmit}
        >
            <>
                <Form onClose={onClose} />
            </>
        </Formik>
    )
}

export { FormCreateUser }